export const IMAGE_VIEWER_STATE_BOTH = 'both';
export const IMAGE_VIEWER_STATE_TEXT = 'text';
export const IMAGE_VIEWER_STATE_IMAGE = 'image';
